import { ProductTileContainer } from "@faire/web-api/indigofair/data/ProductTileContainer";
import React, { PropsWithChildren } from "react";

import { ProductTileClickImpressionProvider } from "@faire/retailer/hooks/ProductTileImpression/ProductTileClickImpressionProvider";
import { ProductTileViewImpressionProvider } from "@faire/retailer/hooks/ProductTileImpression/ProductTileViewImpressionProvider";

interface IProductTileImpressionProviderProps {
  productBasedCollectionToken: string | undefined;
  requestId: string | undefined;
}

export const ProductTileImpressionProvider: React.FC<
  PropsWithChildren<IProductTileImpressionProviderProps>
> = ({ children, productBasedCollectionToken, requestId }) => {
  const context =
    `${ProductTileContainer.PRODUCT_BASED_COLLECTION_LIST}|${productBasedCollectionToken}` as const;

  return (
    <ProductTileViewImpressionProvider context={context} requestId={requestId}>
      <ProductTileClickImpressionProvider
        context={context}
        productTileContainer={
          ProductTileContainer.PRODUCT_BASED_COLLECTION_LIST
        }
        requestId={requestId}
      >
        {children}
      </ProductTileClickImpressionProvider>
    </ProductTileViewImpressionProvider>
  );
};
